const range = (start: number, end: number): number[] =>
    Array.from({ length: end - start + 1 }, (_, index) => start + index);

type TPaginationItem = number | "start-ellipsis" | "end-ellipsis";

const usePagination = (currentPage: number, totalPages: number, siblingsCounts: number): TPaginationItem[] => {
    const innerPages = siblingsCounts * 2 + 3;
    const visiblePages = innerPages + 2;

    if (totalPages > visiblePages) {
        const startPage = Math.max(2, currentPage - siblingsCounts);
        const endPage = Math.min(totalPages - 1, currentPage + siblingsCounts);

        const pages: TPaginationItem[] = range(startPage, endPage);

        const hiddenLeftPages = startPage > 2;
        const hiddenRightPages = totalPages - endPage > 1;
        const pagesOffset = innerPages - (pages.length + 1);

        switch (true) {
            case !hiddenLeftPages && hiddenRightPages: {
                const extraPages = range(endPage + 1, endPage + pagesOffset);
                return [1, ...pages, ...extraPages, "end-ellipsis", totalPages];
            }

            case hiddenLeftPages && !hiddenRightPages: {
                const extraPages = range(startPage - pagesOffset, startPage - 1);
                return [1, "start-ellipsis", ...extraPages, ...pages, totalPages];
            }

            case hiddenLeftPages && hiddenRightPages:
            default:
                return [1, "start-ellipsis", ...pages, "end-ellipsis", totalPages];
        }
    }

    return range(1, totalPages);
};

export default usePagination;
